/**
 * Capitalize the first letter of a string.
 *
 * @param {string} str - The string to capitalize.
 * @returns {string} The input string with the first letter capitalized.
 */
export default function capitalizeString(str) {
  return `${str[0]?.toUpperCase()}${str?.slice(1)}`;
}